/**
 * @param {{
 *   BrandingService: ReturnType<import('../../services/BrandingService').default>,
 * }} param0
 */
export default function brandingUseCase({ BrandingService }) {
  const getBrandingConfigs = (tenantIdentifier = null) =>
    BrandingService.getBrandingConfigs(tenantIdentifier);

  const updateBrandingConfigs = (variables) => BrandingService.updateBrandingConfigs(variables);

  return {
    getBrandingConfigs: getBrandingConfigs,
    updateBrandingConfigs: updateBrandingConfigs,
  };
}
